import { useEffect } from 'react'
import { Modal, Form } from 'antd'
import {
  ProjectEntity,
  UpdateProjectInput,
} from '../../../../../../server-api-hrm.type'
import FormFooterButtons from '../../../../components/re-useable/common-buttons/FormFooterButtons'
import useUpdateProject from '../../hooks/use-update-project'
import FormItemsProject from './FormItems.Project'

interface IProps {
  editingItem?: ProjectEntity
  showDepartment: boolean
  onCancel: () => void
  onFinish: (_res: ProjectEntity) => void
  onDelete?: (_res: ProjectEntity) => void
}

const ModalEditProject = ({
  editingItem,
  showDepartment,
  onCancel,
  onFinish,
  onDelete,
}: IProps) => {
  const [form] = Form.useForm<UpdateProjectInput>()

  const afterCancel = (isOpen: boolean) => {
    if (isOpen) return
    form.resetFields()
  }

  const { loading, handleUpdate } = useUpdateProject({
    onFinish: (res) => {
      onFinish(res)
      onCancel()
    },
  })

  const handleEdit = (value: UpdateProjectInput) => {
    if (editingItem?.id) handleUpdate({ id: editingItem.id, input: value })
  }

  useEffect(() => {
    if (editingItem) form.setFieldsValue(editingItem)
  }, [editingItem])

  return (
    <Modal
      title="Chỉnh sửa"
      open={!!editingItem}
      onCancel={onCancel}
      footer={null}
      width={480}
      afterOpenChange={afterCancel}
    >
      <Form
        form={form}
        name="updateProject"
        onFinish={handleEdit}
        layout="vertical"
      >
        {editingItem ? (
          <FormItemsProject
            form={form}
            data={editingItem}
            showDepartment={showDepartment}
            isTemplate={editingItem.isTemplate ?? false}
          />
        ) : null}

        <FormFooterButtons
          onClickCancel={onCancel}
          loadingSave={loading}
          onClickDelete={() => {
            if (editingItem && typeof onDelete === 'function') {
              onDelete(editingItem)
              onCancel()
            }
          }}
          hideDelete={typeof onDelete !== 'function'}
        />
      </Form>
    </Modal>
  )
}

export default ModalEditProject
